'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../tslib.es6-CZ43up4V.js');
const jsxRuntime = require('react/jsx-runtime');
const utils_mergeClassNames = require('../utils/mergeClassNames.cjs.js');
const designSystem = require('@zapier/design-system');
const React = require('react');
const reactAria = require('react-aria');
const reactAriaComponents = require('react-aria-components');

const popover = "_popover_2ldpy_1";
const popoverContent = "_popover-content_2ldpy_19";
const dialog = "_dialog_2ldpy_35";
const closeButton = "_close-button_2ldpy_39";
const popoverHeaderLayout = "_popover-header-layout_2ldpy_53";
const popoverContentScrollContainer = "_popover-content-scroll-container_2ldpy_61";
const styles = {
	popover: popover,
	popoverContent: popoverContent,
	dialog: dialog,
	closeButton: closeButton,
	popoverHeaderLayout: popoverHeaderLayout,
	popoverContentScrollContainer: popoverContentScrollContainer
};

const Popover = (_a) => {
  var { children, className, color = "dark", onOpenChange, title, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy } = _a, otherProps = tslib_es6.__rest(_a, ["children", "className", "color", "onOpenChange", "title", "aria-label", "aria-labelledby"]);
  const ref = React.useRef(null);
  const { buttonProps } = reactAria.useButton({ onPress: () => onOpenChange && onOpenChange(false) }, ref);
  return jsxRuntime.jsx(reactAriaComponents.Popover, Object.assign({ className: (renderProps) => utils_mergeClassNames.mergeClassNames([styles.popover, className], renderProps), "data-color": color, onOpenChange, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy }, otherProps, { children: (popoverProps) => jsxRuntime.jsx(reactAriaComponents.Dialog, { className: styles.dialog, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, children: jsxRuntime.jsxs(designSystem.Text, { type: "SmallPrint3", color: color === "dark" ? "GrayWarm1" : "GrayWarm10", children: [jsxRuntime.jsxs("div", { className: styles.popoverHeaderLayout, children: [jsxRuntime.jsx(designSystem.Text, { type: "SmallPrint2", color: color === "dark" ? "BrandLavender" : "UiPrimaryStronger", tag: "div", children: title }), jsxRuntime.jsx("button", Object.assign({ ref }, buttonProps, { className: styles.closeButton, type: "button", "aria-label": "close popover", children: jsxRuntime.jsx(designSystem.Icon, { isBlock: true, name: "formX", size: 16, color: color === "dark" ? "GrayWarm1" : "GrayWarm10" }) }))] }), jsxRuntime.jsx("div", { className: styles.popoverContentScrollContainer, children: jsxRuntime.jsx("div", { className: styles.popoverContent, "data-color": color, children: typeof children === "function" ? children(popoverProps) : children }) })] }) }) }));
};

exports.Popover = Popover;
//# sourceMappingURL=Popover.cjs.js.map
